import { render } from "./governance.vue?vue&type=template&id=1ee60469&scoped=true"
import script from "./governance.vue?vue&type=script&lang=js"
export * from "./governance.vue?vue&type=script&lang=js"

import "./governance.vue?vue&type=style&index=0&id=1ee60469&lang=less&scoped=true"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee60469"]])

export default __exports__